import { render } from "./PurchaseView.vue?vue&type=template&id=05269b47"
import script from "./PurchaseView.vue?vue&type=script&lang=js"
export * from "./PurchaseView.vue?vue&type=script&lang=js"

import "./PurchaseView.vue?vue&type=style&index=0&id=05269b47&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__